/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import Layout from '../../components/layout'
import Accordion from '../../components/accordion'
import YouTubePlayer from '../../components/youtubeplayer'
import ContentfulClient from '../../contentful'
import MetaHeaders from '../../components/metaheaders'
import { PATHS, LANDING_PAGE_CONTENTFUL_ID } from '../../utils/vars'
import bannerImg from '../../assets/banner-mem.jpg'
import hayleyImg from '../../assets/hayley.jpg'
import sandyImg from '../../assets/sandy.jpg'
import chrisImg from '../../assets/chris.jpg'
import brainImg from '../../assets/braintext.png'
import modelsImg from '../../assets/models-br.jpg'
import banner from '../../assets/p2pimage.jpg'
import modelsFooterImg from '../../assets/modelsfooter.jpg'
import asSeenImg from '../../assets/asseen.png'
import arrow from '../../assets/membersarrow.svg'

import styles from './Members.module.scss'

const Members = ({ videoId }) => {
    const membersInfo = [
        {
            img: sandyImg,
            text: 'Sandy Gill x urbancoolab',
            info: 'Celebrity stylist, educator, influencer',
        },
        {
            img: chrisImg,
            text: 'Chris Crack x urbancoolab',
            info: 'Musician, cult-classic, influencer',
        },
        {
            img: hayleyImg,
            text: 'Haley Benoit x urbancoolab',
            info: 'Fashion stylist, model coach, influencer',
        },
    ]

    const content = [
        {
            question: 'How much work do I need to do for the Ai to start designing?',
            answer: ['Short answer: Well, it depends how ready you are.', 'Our Ai, STiCH, has a huge database and store of assets and imagery to draw from. It still requires at least 1 input from you in order to make your collection truly yours however. It currently accepts a variety of assets in the form of text keywords, images, and music.', 'If you have all your assets ready for STiCH to process, it could take you less than 30 minutes for you to complete the process. However if you need to spend some time to think and create, then it could take a few days.', 'Remember that what you put in during this process highly influences what you get out. Take the time to do things at your own pace and get your inspiration feeling right.'],
        },
        {
            question: 'What if I don’t like the design?',
            answer: ['Our Ai, STiCH, has analyzed millions of designs and fashion imagery, and the design output generated for you is the best design after having taken your inputs into account. Of course, all art is subjective, and there may be room for some tweaking. If you would like to make some modifications, then please do not hesitate to contact one of our team members at customerservice@urbancoolab.com, who will be more than happy to help you out!'],
        },
        {
            question: 'Who owns the design?',
            answer: ['You own the design! Feel free to apply or modify the design to any non-apparel products that we don’t already supply for you (maybe NFTs?).', 'Please note, that even though you own the design, we still reserve the right to use the design for marketing, promotional, or other business purposes.'],
        },
        {
            question: 'Can I do a three-way collab with another creator or a brand sponsor?',
            answer: ['Yes! We handle multi-party collabs. Our Ai mixes creative inputs from any number of sources to blend and interpret assets. Plan your main visual accordingly and let STiCH handle the rest!'],
        },
        {
            question: 'Can I sell my collection elsewhere?',
            answer: ['Yes! If you want to sell your collection through another store or to a wholesaler, visit our FAQs guide page.', 'We are also more than happy to create a batch order at wholesale prices for your convenience if you do end up deciding to take your collection elsewhere. Just contact our team at customerservice@urbancoolab.com, who all are more than happy to help you out!'],
        },
        {
            question: 'How do I get a sales update and payout?',
            answer: ['We will issue you a sales report by email at the end of each month!', 'Payouts are automated to be issued out to your chosen account at the end of every month if the amount is over USD$100. An amount exceeding USD$2500 will trigger an immediate payout however so you don’t have to wait!'],
        },
        {
            question: 'How much do I make per sale?',
            answer: ['You set the prices for your collection and we split the profit 85/15, you/us! Eg. If you price a hoodie at $70, and profit is $25, you take $22!'],
        },
        {
            question: 'How do I order samples?',
            answer: ['We have a dedicated page on our store for you to order your samples at wholesale prices. You will have the option to customize and pick what colours and sizes you want. Just be sure to include the correct email address while you are placing your order.'],
        },
        {
            question: 'How long does it take to ship products?',
            answer: ['We currently make all items on-demand in order to reduce our ecological footprint. This means that it may take 5 to 10 business days for the garments to be produced, quality checked and ready to be shipped out.', 'We ship internationally to more than 190 countries, so you can build your business anywhere in the world.'],
        },
        {
            question: 'How do I promote my collection?',
            answer: ['The best way to promote your collection would be to engage with your customers and your fans!', 'Don’t forget to take some time to check out our digital book for ideas and inspos! We are launching some collab marketing services soon as well so stay tuned.'],
        },
    ]

    const galleryTile = (img, text, info, influencers) => (
        <div key={info} className={influencers ? styles.galleryItem : styles.memberInfoItem}>
            <img src={img} alt={text} />
            <p className={styles.name}>{text}</p>
            <p className={styles.desc}>{info}</p>
        </div>
    )

    return (
        <>
            <MetaHeaders title="urbancoolab | START YOUR OWN STREETWEAR BRAND" description="START YOUR OWN STREETWEAR BRAND & COLLAB WITH OUR AI DESIGNER. Our mission is to give everyone the tools to design, build, and launch their very own streetwear company. " />
            <Layout>
                <div className={styles.members}>
                    <div className={styles.banner} style={{ backgroundImage: `url(${bannerImg})`, backgroundRepeat: 'no-repeat' }}>
                        <div className={styles.wrapper}>
                            <h2>
                                <span>From Concept to Capsule. We&apos;re a one-stop shop for:</span>
                                <span>
                                    production, e-commerce, fulfilment, customer service
                                </span>
                            </h2>
                            <h1>
                                <span>
                                    Make Money With Design Help By AI.
                                </span>
                                <span>
                                    No Skills Needed. No Commitment.
                                </span>
                                <span>
                                    Limited Slots.
                                </span>
                                <span>
                                    $300 ($2800 in value)
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className={styles.sentenceInfo}>
                        <div className={styles.sentence}>
                            <p>Our AI (powered by Google cloud) will design a full 5-piece capsule for you based on your creative input.</p>
                            <span>($2,000 in value)</span>
                        </div>
                        <div className={styles.sentence}>
                            <p>
                                3 design style prototypes to choose from.
                            </p>
                            <span>
                                No templates. All original.
                            </span>
                        </div>
                        <div className={styles.sentence}>
                            <p>
                                We’ll list your capsule in our store for 6 months from your drop date.
                            </p>
                            <span>
                                ($480 in value)
                            </span>
                        </div>
                        <div className={styles.sentence}>
                            <p>
                                You’ll get access to our official book “How to start a Streetwear Business”
                            </p>
                            <span>
                                ($20 in value)
                            </span>
                        </div>
                        <div className={styles.sentence}>
                            <p>A write-up in Hypecoolture magazine with full SEO</p>
                            <span>($300 in value)</span>
                        </div>
                        <div className={styles.sentence}>
                            <p>Access to batch order support from our merchandise team.</p>
                        </div>
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.videoWrapper}>
                            <YouTubePlayer videoId={videoId} />
                            <a className={styles.getStartedBtn} href={PATHS.UTM1} target="_blank" rel="noopener noreferrer">
                                <button type="button" className="btn p2pbtn">
                                    Get Started
                                    {' '}
                                    <img src={arrow} alt="arrow" />
                                </button>
                            </a>
                        </div>
                        <div className={styles.membersBody}>
                            <div className={styles.squares}>
                                <div className={styles.singleSquare}>
                                    “At first, I wasn’t sure what it’d be like to use artificial intelligence to help me design. It’s actually awesome, like having a Virgil or Nico help me design“ - Marco B.
                                </div>
                                <div className={styles.singleSquare}>
                                    “The AI did an amazing job. I’m finally building my brand and I feel confident enough to get my designs out there. Goodbye to DIY designs!” - Laila S.
                                </div>
                                <div className={styles.singleSquare}>
                                    “I’m selling 20x of product than I was before! Now spending my time promoting my brand and not worrying about churning out new designs!” - Anna J. R.
                                </div>
                                <div className={styles.singleSquare}>
                                    “I made over $20,000 in sales by investing $300! Not needing to worry about my designs, I can now focus on being a creative director and influencer.” - Evan S.
                                </div>
                            </div>

                            <div className={styles.gallery}>
                                {membersInfo.map(({ img, text, info }) => galleryTile(img, text, info, true))}
                            </div>
                            <div className={styles.buttonRight}>
                                <a className={styles.collabBtn} href={PATHS.COLLABS} target="_blank" rel="noopener noreferrer">
                                    <button type="button" className="btn">
                                        explore our collabs
                                        {' '}
                                        <img src={arrow} alt="arrow" />
                                    </button>
                                </a>
                            </div>
                            <img className={styles.brain} src={brainImg} alt="urbancoolab's stich logo" />
                            <div className={styles.info}>
                                <p className={styles.infoTitle}>kick off your fashion empire</p>
                                <span>
                                    for a special price for the
                                    first 100 members
                                </span>
                                <p className={styles.infoNum}>
                                    $300
                                    <span>
                                        $2800 in value
                                    </span>
                                </p>
                                <p className={styles.opportunity}>
                                    Don&apos;t miss this opportunity
                                </p>
                                <a className={styles.getStartedBtn} href={PATHS.UTM2} target="_blank" rel="noopener noreferrer">
                                    <button type="button" className="btn p2pbtn">
                                        Get Started
                                        {' '}
                                        <img src={arrow} alt="arrow" />
                                    </button>
                                </a>
                                <span>
                                    please note: the price might increase in Q4 during peak shopping season traffic
                                </span>
                                <div className={styles.marginBottom} />
                            </div>
                        </div>
                        <div className={styles.chart} style={{ backgroundImage: `url(${modelsImg})`, backgroundRepeat: 'no-repeat' }}>
                            <div className={styles.border}>
                                <div className={styles.table}>
                                    <div className={styles.flexOne}>
                                        <div className={styles.column}>
                                            <p />
                                            <p>PROFESSIONAL DESIGN</p>
                                            <p>PREMIUM BRAND POSITIONING</p>
                                            <p>FULFILMENT & LOGISTICS</p>
                                            <p>INVESTMENT & COMMITMENT</p>
                                        </div>
                                    </div>
                                    <div className={styles.flexTwo}>
                                        <div className={styles.column}>
                                            <p className={styles.bold}>urbancoolab</p>
                                            <p>YES</p>
                                            <p>YES</p>
                                            <p>YES</p>
                                            <p>
                                                $300
                                                {' '}
                                                <span>one-time fee</span>
                                                <span className={styles.tinyFont}>includes:</span>
                                                <span className={styles.tinyFont}>$2,800 in value</span>
                                            </p>
                                        </div>
                                        <div className={styles.column}>
                                            <p className={styles.padding}>merchandise companies</p>
                                            <p>NO</p>
                                            <p>NO</p>
                                            <p>YES</p>
                                            <p>NO</p>
                                        </div>
                                        <div className={styles.column}>
                                            <p className={styles.padding}>building your own full team</p>
                                            <p>YES</p>
                                            <p>NO</p>
                                            <p>NO</p>
                                            <p>YES</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={styles.membersBody}>
                            <div className={styles.empower}>
                                <span>as seen on</span>
                                <img src={asSeenImg} alt="as seen on such publications like sportswear international, complex and design week" />
                            </div>
                        </div>
                        <div className={`${styles.quotes} opacity`}>
                            <h2>Hear what others have to say</h2>
                            <img src={banner} alt="Chris Crack, Sandy Gill, and Layla Lane, UCL charter members" />
                            <div className={styles.quoteFlex}>
                                <div className={styles.quote}>
                                    <p>Working with UCL has been a great experience. The team is responsive & knowledgeable, and their &apos;Stich&apos; AI technology is a fantastic tool that aided in crafting uniquely designed pieces. Teaming up with UCL to launch Chris Crack&apos;s first full collection of apparel under his lifestyle brand, ThanksUncleTrillBrand®, was a great choice. Each piece in the collection was produced on some of the highest quality garments I&apos;ve come across and uniquely packaged to give our customers an elevated unboxing experience. I would 100% recommend collaborating with UCL for your next venture into fashion and merchandise.</p>
                                    <p>- DeJuan Evans</p>
                                    <p>Creative Director for ThanksUncleTrillBrand®</p>
                                    <p><a href="https://www.instagram.com/chriscrackndc/?hl=en" target="_blank" rel="noopener noreferrer">[ @chriscrackndc ]</a></p>

                                </div>
                                <div className={styles.quote}>
                                    <p>Working with UCL has been very easy as an artist. I can just come up with the design and this team handles the execution, production and shipment of the design. As a designer launching my first collection it was really easy for me to create something without stressing so much about the production and shipment and just focusing on the design. The team is also great to work with, responsive and really understanding. I enjoyed my experience and will definitely be working with them again.</p>
                                    <p>- Sandy Gill</p>
                                    <p><a href="https://www.instagram.com/thesandylion/?hl=en" target="_blank" rel="noopener noreferrer">[ @thesandylion ]</a></p>
                                </div>
                                <div className={styles.quote}>
                                    <p>I loved working with urbancoolab! The process was smooth and I loved my end product designs. It was great to be able to modify the AI designs as well.</p>
                                    <p>- Layla Luciano</p>
                                    <p><a href="https://www.instagram.com/laylaluciano/?hl=en" target="_blank" rel="noopener noreferrer">[ @laylaluciano ]</a></p>
                                </div>
                            </div>
                        </div>
                        <img className={styles.modelBanner} src={modelsFooterImg} alt="models wearing urbancoolab merch" />
                        <div className={styles.footer}>
                            <p>This is your opportunity</p>
                            <p>input your inspo. submit designs to Ai. create your capsule. </p>
                            <a className={styles.getStartedBtn} href={PATHS.UTM3} target="_blank" rel="noopener noreferrer">
                                <button type="button" className="btn p2pbtn">
                                    Get Started
                                    {' '}
                                    <img src={arrow} alt="arrow" />
                                </button>
                            </a>
                        </div>
                        <Accordion content={content} />
                        <div className={styles.questions}>
                            <p>Got questions?</p>
                            <p>
                                Hit us up on instagram (
                                <a href="https://www.instagram.com/urbancoolab_/?hl=en" target="_blank" rel="noopener noreferrer">@urbancoolab_</a>
                                ) or drop us an email at
                                {' '}
                                <a href="mailto:human@urbancoolab.com">human@urbancoolab.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

Members.getInitialProps = async () => {
    const res = await ContentfulClient.getEntries({ include: 3, 'sys.id': LANDING_PAGE_CONTENTFUL_ID })
    return {
        ...res.items[0].fields,
    }
}

Members.propTypes = {
    videoId: PropTypes.string.isRequired,
}

export default Members
